import { render } from "./FooterPa.vue?vue&type=template&id=5d0b8902&scoped=true"
import script from "./FooterPa.vue?vue&type=script&lang=js"
export * from "./FooterPa.vue?vue&type=script&lang=js"

import "./FooterPa.vue?vue&type=style&index=0&id=5d0b8902&lang=scss&scoped=true"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0b8902"]])

export default __exports__